<template>
  <div class="ccui-app-box-iframe-operate-container">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <!--    <div class="detail-info-el-Label">-->
    <!--      <el-label :type="labelType" style="height: 100px;"></el-label>-->
    <!--    </div>-->
    <div class="ccui-app-iframe-container-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <el-tabs class="el-tabs__customize" value="1">
          <el-tab-pane :label="breadcrumbData.titname" name="1">
            <template v-if="supPackFlag">
              <el-tabs class="customeTab" v-model="active">
                <el-tab-pane
                  v-for="(listItem, listIndex) in listData"
                  :key="listItem.packId"
                  :label="listItem.packName"
                  :name="'' + listIndex"
                >
                  <el-table
                    :data="listItem.data"
                    border
                    :span-method="spanMethod"
                  >
                    <template v-for="(item, index) in listItem.columns">
                      <el-table-column
                        :key="index"
                        :show-overflow-tooltip="true"
                        v-bind="item"
                        v-if="item.labelChild && item.labelChild.length > 0"
                      >
                        <template v-for="(child, indexch) in item.labelChild">
                          <el-table-column
                            :key="indexch"
                            align="center"
                            v-bind="child"
                          >
                            <template slot="header">
                              <div class="el-tooltip">{{ child.label }}</div>
                            </template>
                          </el-table-column>
                        </template>
                        <template slot-scope="scope">
                          <span v-if="item.money">{{
                            scope.row[item.prop] !== ""
                              ? new BigNumber(scope.row[item.prop]).toFormat(2)
                              : ""
                          }}</span>
                          <span v-else>{{ scope.row[item.prop] }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :key="index"
                        :show-overflow-tooltip="true"
                        v-bind="item"
                        v-else-if="!item.labelChild"
                      >
                        <template slot-scope="scope">
                          <span v-if="item.money">{{
                            scope.row[item.prop] !== ""
                              ? new BigNumber(scope.row[item.prop]).toFormat(2)
                              : ""
                          }}</span>
                          <span v-else>{{ scope.row[item.prop] }}</span>
                        </template>
                      </el-table-column>
                    </template>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </template>
            <template v-else>
              <div v-for="(listItem, listIndex) in listData" :key="listIndex">
                <el-table
                  :data="listItem.data"
                  border
                  :span-method="spanMethod"
                >
                  <template v-for="(item, index) in listItem.columns">
                    <el-table-column
                      :key="index"
                      :show-overflow-tooltip="true"
                      v-bind="item"
                      v-if="item.labelChild && item.labelChild.length > 0"
                    >
                      <el-table-column
                        v-for="(child, indexch) in item.labelChild"
                        :key="indexch"
                        align="center"
                        v-bind="child"
                      >
                        <template slot="header">
                          <div class="el-tooltip">{{ child.label }}</div>
                        </template>
                        <template slot-scope="scope">
                          <span v-if="child.money">{{
                            scope.row[child.prop] !== ""
                              ? new BigNumber(scope.row[child.prop]).toFormat(2)
                              : ""
                          }}</span>

                          <span v-else>{{ scope.row[child.prop] }}</span>
                        </template>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column
                      :key="index"
                      :show-overflow-tooltip="true"
                      v-bind="item"
                      v-else-if="!item.labelChild"
                    >
                      <template slot-scope="scope">
                        <span v-if="item.money">{{
                          scope.row[item.prop] !== ""
                            ? new BigNumber(scope.row[item.prop]).toFormat(2)
                            : ""
                        }}</span>
                        <span v-else>{{ scope.row[item.prop] }}</span>
                      </template>
                    </el-table-column>
                  </template>
                </el-table>
              </div>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="operate">
      <el-button
        type="text"
        icon="icon-ccui-return"
        @click="dealExpertSupScoreCancel"
        >退回评分</el-button
      >
      <!--      <template v-if="listData[active].summaryTableData.length === 0">-->
      <el-button
        type="text"
        icon="icon-ccui-data"
        v-preventReClick
        @click="operateSummary"
        >汇总</el-button
      >
      <!--      </template>-->
      <!--      <template v-if="listData[active].summaryTableData.length > 0">-->
      <!--      <el-button-->
      <!--        type="text"-->
      <!--        icon="el-icon-refresh-right"-->
      <!--        @click="operateSummary"-->
      <!--        >重新汇总</el-button-->
      <!--      >-->
      <!--      </template>-->
      <!--      <el-button type="text" icon="icon-ccui-agree" @click="dealSumScoreSubmit"-->
      <!--        >提交</el-button-->
      <!--      >-->
      <el-button type="text" icon="icon-ccui-sharing-o" @click="refresh"
        >刷新</el-button
      >
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="
        `分包商${
          purchaseType == 1 ||
          purchaseType == 2 ||
          purchaseType == 4 ||
          purchaseType == 7 ||
          purchaseType == 8
            ? '响应'
            : '投标'
        }详细信息`
      "
      width="1200px"
      v-if="dialogVisible"
    >
      <supplierBidDetails
        :supQuoteId="formData.supQuoteId"
        :supPackQuoteId="formData.supPackQuoteId"
        :supCode="formData.supCode"
        :packId="formData.packId"
      ></supplierBidDetails>
      <div slot="footer"></div>
    </el-dialog>
    <el-dialog
      :visible.sync="expertDialogVisible"
      title="专家列表"
      width="1200px"
      v-if="expertDialogVisible"
    >
      <el-table
        :data="expertTableData"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          property="expertSourceStr"
          label="专家来源"
          show-overflow-tooltip
          width="180"
        ></el-table-column>
        <el-table-column
          property="expertName"
          label="专家姓名"
          show-overflow-tooltip
          width="180"
        ></el-table-column>
        <el-table-column
          property="expertRoleStr"
          label="专家角色"
          show-overflow-tooltip
          width="180"
        ></el-table-column>
        <el-table-column
          property="workUnitName"
          label="工作单位"
          show-overflow-tooltip
          width="180"
        ></el-table-column>
        <el-table-column
          property="signFlag"
          label="签到情况"
          show-overflow-tooltip
          width="180"
        ></el-table-column>
        <el-table-column
          property="signTime"
          label="签到时间"
          show-overflow-tooltip
          width="180"
        ></el-table-column>
      </el-table>
      <div slot="footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="expertDialogVisible = false"
          >取消</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="sureExpert"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import supplierBidDetails from "@/app/subSourcingFlow/views/supplierBidDetails.vue";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  scpQrySumScorePackListApi,
  scpQrySumScoreExpertScoreListApi,
  scpQryNotSubmitScoreExpertListApi,
  scpDealExpertSupScoreCancelApi,
  scpDealSumScoreSubmitApi,
  scpQryBidEvaProcessStatusApi,
  scpQryJoinExpertListApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";

import BigNumber from "bignumber.js";
export default {
  name: "noSummary",
  components: {
    supplierBidDetails,
    breadcrumbSourcing
  },
  inject: ["reload"],
  props: {
    type: {
      type: Number, // 0: 技术评分汇总 1：商务技术评分汇总
      default: 0
    }
  },
  data() {
    // let unit = JSON.parse(sessionStorage.getItem("moneyData")).unit;
    return {
      BigNumber: BigNumber,
      breadcrumbData: {
        titname: "打分汇总",
        status: "未汇总"
      },
      labelType: "NotSummary",
      dialogVisible: false,
      listData: [],
      active: "0",
      skillHeaders: [],
      commonHeader: [],
      formData: {
        supQuoteId: "",
        supPackQuoteId: "",
        supCode: "",
        packId: ""
      },
      columns: [],
      columnCopy: [
        {
          prop: "id",
          label: "序号",
          width: 55,
          fixed: true
        },
        {
          prop: "expertName",
          label: "评分专家",
          width: 170,
          fixed: true
        },
        {
          prop: "supName",
          label: "分包商",
          "min-width": 200,
          fixed: true
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        // {
        //   prop: "taxAmount",
        //   label: "税额（" + unit + "）",
        //   width: 180,
        //   align: "right",
        //   money: true
        // },
        // {
        //   prop: "noTaxPriceAmount",
        //   label: "不含税金额（" + unit + "）",
        //   width: 200,
        //   align: "right",
        //   money: true
        // },
        // {
        //   prop: "priceAmount",
        //   label: "含税金额（" + unit + "）",
        //   width: 180,
        //   align: "right",
        //   money: true
        // },
        {
          prop: "supScore",
          label: "汇总得分",
          width: 80
        },
        {
          prop: "scoreDesc",
          label: "打分说明",
          "min-width": 220
        },
        {
          prop: "updateTime",
          label: "评分提交时间",
          width: 170
        }
      ],
      evaForm: JSON.parse(sessionStorage.getItem("bidEvaPrepareDetailData"))
        .evaForm, // 1：技术商务组合评分 2：技术商务分开评分
      supPackFlag: false, // 是否分包件 false:不分包
      purchaseType: "",
      expertDialogVisible: false,
      expertTableData: [], //专家列表数据
      expertSelection: [] //选择的退回专家
    };
  },
  mounted() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      // this.columnCopy.splice(5, 1);
      this.columns = this.columnCopy;
    } else {
      this.columns = this.columnCopy;
    }
    this.getData();
  },
  methods: {
    getData() {
      scpQrySumScorePackListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        sumScoreType: this.type == 0 ? "0" : this.evaForm == "1" ? "2" : "1" // 技术商务评分汇总并且组合评分的时候才查询技术商务，分开评分的时候只查询商务
        // sumScoreType: this.type == 0 ? "0" :"2" // 技术商务评分汇总并且组合评分的时候才查询技术商务，分开评分的时候只查询商务
      }).then(res => {
        this.supPackFlag = res.data.data.supPackFlag;
        let arr = [];
        if (res.data.data.supPackFlag) {
          res.data.data.notSumScorePack.forEach(item => {
            // 看是否流标 packStatus 1正常5流标
            if (item.packStatus == "1") {
              arr.push(
                this.qrySumScoreExpertScoreList(item.packId, item.packName)
              );
            }
          });
        } else {
          arr.push(this.qrySumScoreExpertScoreList("", ""));
        }
        Promise.all(arr).then(res1 => {
          if (res1 && res1.length > 0) {
            // 通过包件id进行排序
            res1.sort(function(a, b) {
              if (a.joinExpertId > b.joinExpertId) {
                return 1;
              } else if (a.joinExpertId < b.joinExpertId) {
                return -1;
              } else {
                return 0;
              }
            });
            res1.forEach((item, index) => {
              item.columns = JSON.parse(JSON.stringify(this.columns));
              // 技术评分汇总
              if (this.type == 0) {
                item.columns.splice(5, 0, {
                  prop: "sscScoreItemBOS",
                  label: "技术",
                  labelChild: [],
                  align: "center"
                });
                item.columns.splice(6, 0, {
                  prop: "sscScoreItemBOS",
                  label: "技术加分项",
                  labelChild: [],
                  align: "center"
                });
              }
              // 技术商务评分汇总
              if (this.type == 1) {
                // if (this.evaForm == "1") {
                // 组合评分
                item.columns.splice(5, 0, {
                  prop: "sscScoreItemBOS",
                  label: "技术",
                  labelChild: [],
                  align: "center"
                });
                item.columns.splice(6, 0, {
                  prop: "sscScoreItemBOS",
                  label: "技术加分项",
                  labelChild: [],
                  align: "center"
                });
                item.columns.splice(7, 0, {
                  prop: "sscCommonScoreItemBOS",
                  label: "商务",
                  labelChild: [],
                  align: "center"
                });
                item.columns.splice(8, 0, {
                  prop: "sscScoreItemBOS",
                  label: "商务加分项",
                  labelChild: [],
                  align: "center"
                });
                // }
                // if (this.evaForm == "2") {
                //   // 分开评分
                //   item.columns.splice(5, 0, {
                //     prop: "sscCommonScoreItemBOS",
                //     label: "商务",
                //     labelChild: [],
                //     align: "center"
                //   });
                //   item.columns.splice(6, 0, {
                //     prop: "sscScoreItemBOS",
                //     label: "商务加分项",
                //     labelChild: [],
                //     align: "center"
                //   });
                // }
              }
              let skillChild = []; // 技术评分的表头
              let commonChild = []; // 商务评分的表头
              let commonChild2 = []; // 技术加分项
              let commonChild3 = []; // 商务加分项
              let devspan = 0; // 之前行的数
              let data = []; // 数据
              let id = 0; // 序号
              item.expertList.forEach((aItem, aIndex) => {
                id++;
                if (aIndex > 0) {
                  devspan +=
                    item.expertList[aIndex - 1].sscSupQuoteScoreBOS.length;
                  // item.expertList[aIndex - 1].sscSupQuoteScoreBOS.forEach(a => {
                  //   devspan += a.sscSupScoreBOS.length;
                  // });
                }
                aItem.sscSupQuoteScoreBOS.forEach((bItem, bIndex) => {
                  let columnCount = 11; // 总共有多少列，用于计算最后一列的合并
                  bItem.sscSupScoreBOS.forEach(b => {
                    columnCount += b.sscSupScoreItemBOS.length;
                  });
                  let obj = {
                    id: id,
                    joinExpertId: aItem.joinExpertId,
                    expertName: aItem.expertName,
                    supJoinId: bItem.supJoinId,
                    supQuoteId: bItem.supQuoteId,
                    supCode: bItem.supCode,
                    supName: bItem.supName,
                    priceAmount: bItem.priceAmount,
                    noTaxPriceAmount: bItem.noTaxPriceAmount,
                    taxAmount: bItem.taxAmount,
                    supScore: bItem.supScore,
                    scoreDesc: bItem.scoreDesc,
                    updateTime: bItem.updateTime,
                    devspan: devspan,
                    rowspan: aItem.sscSupQuoteScoreBOS.length,
                    columnCount: columnCount,
                    industryTypeName: bItem.industryTypeName,
                    companyTypeName: bItem.companyTypeName
                  };
                  bItem.sscSupScoreBOS.forEach((cItem, cIndex) => {
                    cItem.sscSupScoreItemBOS.forEach((dItem, dIndex) => {
                      obj.scoreRule = dItem.scoreRule;
                      let props =
                        "supScore-" + cItem.scoreItem + "-" + dItem.scoreItemId;
                      obj[props] =
                        dItem.supScore &&
                        new BigNumber(dItem.supScore).toFormat(2);
                      if (this.type == 0) {
                        // 技术评分汇总
                        if (cItem.scoreItem === "0") {
                          if (
                            skillChild.filter(item => {
                              return (
                                item.prop ===
                                "supScore-" +
                                  cItem.scoreItem +
                                  "-" +
                                  dItem.scoreItemId
                              );
                            }).length === 0
                          ) {
                            skillChild.push({
                              prop: props,
                              label: dItem.scoreRule,
                              width: 120
                            });
                          }
                        }
                        if (cItem.scoreItem === "2") {
                          if (
                            commonChild2.filter(item => {
                              return (
                                item.prop ===
                                "supScore-" +
                                  cItem.scoreItem +
                                  "-" +
                                  dItem.scoreItemId
                              );
                            }).length === 0
                          ) {
                            commonChild2.push({
                              prop: props,
                              label: dItem.scoreRule,
                              width: 120
                            });
                          }
                        }
                      }
                      if (this.type == 1) {
                        // 技术商务评分汇总
                        // if (this.evaForm == "1") {
                        // 技术商务组合评分
                        if (cItem.scoreItem === "0") {
                          if (
                            skillChild.filter(item => {
                              return (
                                item.prop ===
                                "supScore-" +
                                  cItem.scoreItem +
                                  "-" +
                                  dItem.scoreItemId
                              );
                            }).length === 0
                          ) {
                            skillChild.push({
                              prop: props,
                              label: dItem.scoreRule,
                              width: 120
                            });
                          }
                        }
                        if (cItem.scoreItem === "1") {
                          if (
                            commonChild.filter(item => {
                              return (
                                item.prop ===
                                "supScore-" +
                                  cItem.scoreItem +
                                  "-" +
                                  dItem.scoreItemId
                              );
                            }).length === 0
                          ) {
                            commonChild.push({
                              prop: props,
                              label: dItem.scoreRule,
                              width: 120
                            });
                          }
                        }
                        if (cItem.scoreItem === "2") {
                          if (
                            commonChild2.filter(item => {
                              return (
                                item.prop ===
                                "supScore-" +
                                  cItem.scoreItem +
                                  "-" +
                                  dItem.scoreItemId
                              );
                            }).length === 0
                          ) {
                            commonChild2.push({
                              prop: props,
                              label: dItem.scoreRule,
                              width: 120
                            });
                          }
                        }
                        if (cItem.scoreItem === "3") {
                          if (
                            commonChild3.filter(item => {
                              return (
                                item.prop ===
                                "supScore-" +
                                  cItem.scoreItem +
                                  "-" +
                                  dItem.scoreItemId
                              );
                            }).length === 0
                          ) {
                            commonChild3.push({
                              prop: props,
                              label: dItem.scoreRule,
                              width: 120
                            });
                          }
                        }
                        // }
                        // 技术商务分开评分
                        // if (this.evaForm == "2") {
                        //   if (cItem.scoreItem === "1") {
                        //     if (
                        //       commonChild.filter(item => {
                        //         return (
                        //           item.prop ===
                        //           "supScore-" +
                        //             cItem.scoreItem +
                        //             "-" +
                        //             dItem.scoreItemId
                        //         );
                        //       }).length === 0
                        //     ) {
                        //       commonChild.push({
                        //         prop: props,
                        //         label: dItem.scoreRule,
                        //         width: 120
                        //       });
                        //     }
                        //   }
                        //   if (cItem.scoreItem === "3") {
                        //     if (
                        //       commonChild3.filter(item => {
                        //         return (
                        //           item.prop ===
                        //           "supScore-" +
                        //             cItem.scoreItem +
                        //             "-" +
                        //             dItem.scoreItemId
                        //         );
                        //       }).length === 0
                        //     ) {
                        //       commonChild3.push({
                        //         prop: props,
                        //         label: dItem.scoreRule,
                        //         width: 120
                        //       });
                        //     }
                        //   }
                        // }
                      }
                    });
                  });
                  data.push(obj);
                });
              });
              console.log("item.columns1", item.columns);
              // if (skillChild.length + commonChild.length < 3) {
              // if (this.type == 1) {
              //   delete item.columns[6].width;
              // } else {
              //   delete item.columns[6].width;
              // }
              // }
              if (this.type == 0) {
                item.columns[5].labelChild = skillChild;
                item.columns[6].labelChild = commonChild2;
              }
              if (this.type == 1) {
                // if (this.evaForm == "1") {
                // 组合评分
                item.columns[5].labelChild = skillChild;
                item.columns[6].labelChild = commonChild2;
                item.columns[7].labelChild = commonChild;
                item.columns[8].labelChild = commonChild3;
                // }
                // if (this.evaForm == "2") {
                //   // 组合评分
                //   item.columns[5].labelChild = commonChild;
                //   item.columns[6].labelChild = commonChild3;
                // }
              }
              // console.log("item.columns2", item.columns);
              item.data = data;
            });
          }
          this.listData = res1;
          // console.log("this.listData", this.listData);
        });
      });
    },
    qrySumScoreExpertScoreList(packId, packName) {
      return new Promise((resolve, reject) => {
        scpQrySumScoreExpertScoreListApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: packId
          // scoreItem: this.type == 0 ? "0" : this.evaForm == "1" ? "" : "1"
        }).then(res => {
          let obj = {
            packId: packId,
            packName: packName,
            expertList: res.data.data
          };
          resolve(obj);
        });
      });
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 2 || columnIndex === row.columnCount - 1) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    viewBidFile(row) {
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supCode = row.supCode;
      this.formData.packId = this.listData[this.active].packId;
      this.dialogVisible = true;
    },
    operateSummary() {
      // 汇总的时候有的专家可能还没有提交评分 如果一个都没有提交是不允许汇总的
      scpQryNotSubmitScoreExpertListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        packId: this.listData[this.active].packId,
        scoreItem: this.type == 0 ? "0" : this.evaForm == "1" ? "" : "1",
        isShowPageLoading: true
      }).then(res => {
        if (res.data.data.expertSubmitFlag != "1") {
          this.$router.push({
            name: "scpOperateSkillOrCommonSummaryNew",
            query: {
              type: this.type,
              packId: this.listData[Number(this.active)].packId,
              a: this.$router.history.current.query.a,
              menuKey: this.$router.history.current.query.menuKey,
              evaPurStep: this.$router.history.current.query.evaPurStep
            }
          });
        } else {
          this.$message({
            message: "没有专家提交评分，不能进行汇总，请先进行评分提交！",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        }
      });
    },
    handleSelectionChange(val) {
      this.expertSelection = val;
    },
    // 撤销评分
    dealExpertSupScoreCancel() {
      this.expertDialogVisible = true;
      this.getExpertData();
    },
    getExpertData() {
      scpQryJoinExpertListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,

        evaPurStep: this.$router.history.current.query.evaPurStep,
        bidEvaId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .bidEvaId
      }).then(res => {
        this.expertTableData = res.data.data.rows;
      });
    },

    //选择专家退回评分
    sureExpert() {
      if (this.expertSelection.length == 0) {
        this.$message({
          message: "还未选择专家",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      } else {
        let cancelJoinExpertIds = [];
        this.expertSelection.forEach(item => {
          cancelJoinExpertIds.push(item.joinExpertId);
        });
        this.$confirm(
          "您确定要指定专家退回评分吗？退回后，需专家重新提交评分？",
          "撤销评分",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "ccui-message-box-custom"
          }
        )
          .then(() => {
            scpDealExpertSupScoreCancelApi({
              schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                .schemeId,
              joinExpertId: sessionStorage.getItem("joinId"),
              scoreType: this.type == 0 ? 0 : this.evaForm == "1" ? 2 : 1,
              cancelJoinExpertIds: cancelJoinExpertIds
            }).then(res => {
              if (res.data.code == "0") {
                this.refresh();
                this.$message({
                  message: "退回评分成功！",
                  type: "success",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
              }
            });
          })
          .catch(() => {});
      }
    },
    // 提交
    dealSumScoreSubmit() {
      // 汇总的时候有的专家可能还没有提交评分 如果存在没有评分是不允许提交的
      scpQryNotSubmitScoreExpertListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        packId: this.listData[this.active].packId,
        scoreItem: this.type == 0 ? "0" : this.evaForm == "1" ? "" : "1"
      }).then(res => {
        if (res.data.data.expertSubmitFlag != "3") {
          this.$confirm(
            `评标专家：“${res.data.data.expertNames}”还未提交评分表，您是否确定要提交汇总表？汇总表提交后，此信息将不允许重新汇总。`,
            "提交汇总",
            {
              distinguishCancelAndClose: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              customClass: "ccui-message-box-custom"
            }
          )
            .then(() => {
              scpDealSumScoreSubmitApi({
                schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                  .schemeId,
                joinExpertId: sessionStorage.getItem("joinId"),
                sumScoreType: this.type == 0 ? 0 : 2
              }).then(res => {
                this.$message({
                  message: "汇总表提交成功！",
                  type: "success",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
                this.refresh();
              });
            })
            .catch(() => {});
        } else {
          scpDealSumScoreSubmitApi({
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            joinExpertId: sessionStorage.getItem("joinId"),
            sumScoreType: this.type == 0 ? 0 : 2
          }).then(res => {
            this.$message({
              message: "汇总表提交成功！",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            this.refresh();
          });
        }
      });
    },
    // 刷新
    refresh() {
      let joinId = JSON.parse(sessionStorage.getItem("expertSourceData"))
        .joinExpertId;
      if (
        this.$router.history.current.query.evaPurStep === "801" ||
        this.$router.history.current.query.evaPurStep === "802"
      ) {
        joinId = sessionStorage.getItem("joinId");
      }
      scpQryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: joinId,
        evaPurStep: this.$router.history.current.query.evaPurStep,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.active = "0";
        this.getData();
        this.reload();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-table td {
  padding: 0 !important;
}
/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}
</style>
